import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { EditPanelPreferencePage } from '@/areas/settings/pcb/OrganizationSettings/PcbPage/EditPanelPreferencePage';
import { canEditPanelPreferences } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/settings/_menu/organization/pcb/panel-preferences/$panelPreferenceId/edit',
)({
    staticData: { access: { permissions: canEditPanelPreferences }, chrome: 'home' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <EditPanelPreferencePage {...pathParams} />;
}
